import {useNavigate} from 'react-router-dom';
import DefaultImage from '../../../../../../../assets/image/newShop/defaultImg.png';
import {IsAdvertisementCloseToExpire} from '../../../../../advertismentDetail/helper/IsAdvertisementCloseToExpire';
import {discountedAdvertisementPrice} from '../../helper/discountedAdvertisementPrice';
import AvailableQuantityEditButton from '../AvailableQuantityEditButton';

const PublishedAdvertisementCard = ({
  storeAd,
}: {
  storeAd: IGetMyStoreAdsData;
}) => {
  const navigate = useNavigate();

  const imageSrc =
    storeAd?.main_image?.image_330 ??
    storeAd?.sub_brand_main_image?.image ??
    DefaultImage;

  const adPrice = storeAd?.ad_price ?? 0;
  const discountAmount = storeAd?.discount_amount;

  const trueAdPrice = discountedAdvertisementPrice(adPrice, discountAmount);

  return (
    <div className="relative border-[1px] border-gray-300 shadow-sm shadow-gray-100 rounded-lg p-3 gap-3 flex flex-col text-md">
      {IsAdvertisementCloseToExpire(storeAd?.expiration_date) && (
        <span className="absolute top-4 left-4 text-xs font-medium text-amber-600">
          نزدیک به انقضا
        </span>
      )}
      <div className="flex gap-2">
        <img
          src={imageSrc}
          alt="عکس آگهی"
          className="object-contain rounded-lg size-28"
        />
        <div className="flex flex-col ml-2 space-y-4 w-full">
          <span className="block overflow-hidden mt-2 w-full min-w-0 font-medium whitespace-nowrap text-neutral-900 text-ellipsis line-clamp-1 max-w-48">
            {storeAd?.title}
          </span>

          <div className="flex justify-between items-center ml-4">
            <span className="text-gray-600">قیمت</span>
            <span className="text-zinc-600">
              {trueAdPrice
                ? trueAdPrice?.toLocaleString() + ' تومان'
                : 'تعیین نشده'}
            </span>
          </div>

          <div className="flex justify-between items-center ml-4">
            <span className="text-gray-600">موجودی</span>
            <AvailableQuantityEditButton
              minSellQuantity={storeAd?.min_sell_quantity}
              availableQuantity={storeAd?.available_quantity}
              advertisementGuid={storeAd?.id}
            />
          </div>
        </div>
      </div>
      <div
        className="flex gap-2 justify-end items-center ml-2 font-medium text-left text-farm-shop-500"
        onClick={() => {
          navigate(`/my-ads/advertisment/${storeAd?.id}`, {
            state: {
              type: 'advertisement',
              advertisement_type: storeAd?.advertisement_type,
              from: '/manage-my-store-ads?tab=published',
            },
          });
        }}
      >
        <i className="text-xl icon-nameEdit-Square" />
        <span>ویرایش و مدیریت آگهی</span>
      </div>
    </div>
  );
};

export default PublishedAdvertisementCard;
